import Router from './routes';
import './App.css';
import ReactFullscreen from 'react-easyfullscreen';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { screenStatus } from './redux/features/settingsSlice';
import { transitionStatus, sideBarSettings } from './redux/features/settingsSlice';
// import useSocketNotifications from "./Hooks/useSocketNotifications";
// import NotificationSnackbar from "./components/snackbar/NotificationSnackbar";
import { SnackbarProvider, useSnackbar } from 'notistack';
import { setSnackbar } from './api/request';
// import EngagementLeaderboardWidget from './views/engagement/EngagementLeaderboardWidget'; // disabled, see below
import EngagementRegistrationPrompt from './views/engagement/EngagementRegistrationPrompt';

function App() {
  const dispatch = useDispatch();
  const status = useSelector((state) => state.settings);

  // useSocketNotifications();

  useEffect(() => {
    dispatch(
      sideBarSettings({
        bgColor: 'default',
        color: '',
      })
    );
    dispatch(screenStatus('NotActive'));
    dispatch(
      transitionStatus({
        transition: 'Fade',
        otherProps: '',
      })
    );
  }, []);
  const SnackbarInitializer = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
      setSnackbar(enqueueSnackbar);
    }, [enqueueSnackbar]);
    return children;
  };

  return (
    // <ReactFullscreen>
    //     {({ ref, onRequest, onExit }) => (
    <>
      {/* {status.screenStatus === "Active" ? onRequest() : onExit()} */}
      <SnackbarProvider maxSnack={3}>
        <SnackbarInitializer>
            <Router />
            {/* Floating Employee Engagement leaderboard tab - switched off for now (2026-10-23). Drop the comment
                markers here and on the import above to bring it back. */}
            {/* <EngagementLeaderboardWidget /> */}
            <EngagementRegistrationPrompt />
          {/* <NotificationSnackbar /> */}
        </SnackbarInitializer>
      </SnackbarProvider>
      ,
    </>
    //     )}
    // </ReactFullscreen>
  );
}

export default App;
